import { render, staticRenderFns } from "./ComputerGroups.vue?vue&type=template&id=16c8ecc8&"
import script from "./ComputerGroups.vue?vue&type=script&lang=js&"
export * from "./ComputerGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports